import React, { useState } from 'react';
import ClickThroughRate from './ClickThroughRateIcon.png';
import styled from 'styled-components';

const FixedIcon = styled.svg`
  width: ${({ dimention }) => dimention};
  height: ${({ dimention }) => dimention};
  min-width: ${({ dimention }) => dimention};
  min-height: ${({ dimention }) => dimention};
  max-width: ${({ dimention }) => dimention};
  max-height: ${({ dimention }) => dimention};
  flex: 0 0 ${({ dimention }) => dimention};
  display: inline-block;
`;

const BLUE_COLOR = '#007ADE';

export const AllChannelsIcon = ({ color }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <FixedIcon
      dimention="14px"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <path
        d="M5.83333 1.75H1.75V5.83333H5.83333V1.75Z"
        stroke={isHovered ? BLUE_COLOR : color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 1.75H8.16667V5.83333H12.25V1.75Z"
        stroke={isHovered ? BLUE_COLOR : color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 8.16667H8.16667V12.25H12.25V8.16667Z"
        stroke={isHovered ? BLUE_COLOR : color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83333 8.16667H1.75V12.25H5.83333V8.16667Z"
        stroke={isHovered ? BLUE_COLOR : color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </FixedIcon>
  );
};

export const EmailIcon = ({ color }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <FixedIcon
      dimention="14px"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <path
        d="M12.8333 3.49999C12.8333 2.85833 12.3083 2.33333 11.6666 2.33333H2.33329C1.69163 2.33333 1.16663 2.85833 1.16663 3.49999M12.8333 3.49999V10.5C12.8333 11.1417 12.3083 11.6667 11.6666 11.6667H2.33329C1.69163 11.6667 1.16663 11.1417 1.16663 10.5V3.49999M12.8333 3.49999L6.99996 7.58333L1.16663 3.49999"
        stroke={isHovered ? BLUE_COLOR : color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </FixedIcon>
  );
};

export const TextIcon = ({ color }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <FixedIcon
      dimention="14px"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <path
        d="M6.99996 10.5H7.00579M4.08329 1.16667H9.91663C10.561 1.16667 11.0833 1.68901 11.0833 2.33334V11.6667C11.0833 12.311 10.561 12.8333 9.91663 12.8333H4.08329C3.43896 12.8333 2.91663 12.311 2.91663 11.6667V2.33334C2.91663 1.68901 3.43896 1.16667 4.08329 1.16667Z"
        stroke={isHovered ? BLUE_COLOR : color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </FixedIcon>
  );
};

export const DeliveryRateIcon = () => (
  <FixedIcon
    dimention="37px"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.41125 9.29625L16.9892 14.2604L5.39583 12.7188L5.41125 9.29625ZM16.9738 22.7396L5.39583 27.7037V24.2812L16.9738 22.7396ZM2.32792 4.625L2.3125 15.4167L25.4375 18.5L2.3125 21.5833L2.32792 32.375L34.6875 18.5L2.32792 4.625Z"
      fill="#007ADE"
    />
  </FixedIcon>
);

export const OpenRateIcon = () => (
  <FixedIcon
    dimention="37px"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.9013 14.6458C33.9013 13.5358 33.3309 12.5646 32.4521 12.025L18.5 3.85416L4.54796 12.025C3.66921 12.5646 3.08337 13.5358 3.08337 14.6458V30.0625C3.08337 31.7583 4.47087 33.1458 6.16671 33.1458H30.8334C32.5292 33.1458 33.9167 31.7583 33.9167 30.0625L33.9013 14.6458ZM30.818 14.6458V14.6612L18.5 22.3542L6.16671 14.6458L18.5 7.43082L30.818 14.6458ZM6.16671 30.0625V18.2533L18.5 25.9925L30.818 18.2996L30.8334 30.0625H6.16671Z"
      fill="#007ADE"
    />
  </FixedIcon>
);

export const BounceRateIcon = () => (
  <FixedIcon
    dimention="37px"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5 22.6163L5.25706 9.38875L3.08331 11.5625L16.1875 24.6667H6.16665V27.75H30.8333V24.6667H20.8125L28.7521 16.7271C29.1529 16.8813 29.6 16.9583 30.0625 16.9583C32.19 16.9583 33.9166 15.2317 33.9166 13.1042C33.9166 10.9767 32.19 9.25 30.0625 9.25C27.935 9.25 26.2083 10.9767 26.2083 13.1042C26.2083 13.6437 26.3162 14.1371 26.5166 14.5996L18.5 22.6163Z"
      fill="#007ADE"
    />
  </FixedIcon>
);

export const DropRateIcon = () => (
  <FixedIcon
    dimention="37px"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.6667 27.75L28.1971 24.2196L20.6738 16.6962L14.5071 22.8629L3.08337 11.4237L5.25712 9.25L14.5071 18.5L20.6738 12.3333L30.3863 22.0304L33.9167 18.5V27.75H24.6667Z"
      fill="#007ADE"
    />
  </FixedIcon>
);

export const SpamReportIcon = () => (
  <FixedIcon
    dimention="37px"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.2504 4.625H12.7496L4.625 12.7496V24.2504L12.7496 32.375H24.2504L32.375 24.2504V12.7496L24.2504 4.625ZM29.2917 22.9708L22.9708 29.2917H14.0292L7.70833 22.9708V14.0292L14.0292 7.70833H22.9708L29.2917 14.0292V22.9708Z"
      fill="#007ADE"
    />
    <path
      d="M18.5 26.2083C19.3514 26.2083 20.0417 25.5181 20.0417 24.6667C20.0417 23.8152 19.3514 23.125 18.5 23.125C17.6486 23.125 16.9583 23.8152 16.9583 24.6667C16.9583 25.5181 17.6486 26.2083 18.5 26.2083Z"
      fill="#007ADE"
    />
    <path
      d="M16.9583 10.7917H20.0417V21.5833H16.9583V10.7917Z"
      fill="#007ADE"
    />
  </FixedIcon>
);

export const ClickThroughRateIcon = () => {
  return (
    <img src={ClickThroughRate} alt="Description" width="37" height="37" />
  );
};
